"use client";
import React from "react";
import SliderBanner from "../components/SliderBanner";
import UygunTurFormu from "../components/UygunTurFormu";

// Görselleri import et
import doha from "../assets/doha.jpeg";
import medine from "../assets/medine.jpeg";
import mekke from "../assets/mekke.jpg";
import misir from "../assets/mısır.jpeg";
import saraybosna from "../assets/saraybosna.jpeg";

function Anasayfa() {
  return (
    <div>
      {/* Otomatik geçişli görsel */}
      <SliderBanner />

      {/* Turlarımız Bölümü */}
      <div style={{ padding: "60px 20px", backgroundColor: "#f9f9f9" }}>
        <div style={{ maxWidth: "1300px", margin: "auto" }}>
          <h2
            style={{
              fontSize: "28px",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "40px",
              color: "#272B59",
            }}
          >
            Turlarımız
          </h2>

          {/* 5 kart yanyana */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
              overflowX: "auto", // taşarsa scroll
              paddingBottom: "10px",
            }}
          >
            {[
              { title: "Umre Turu", img: mekke },
              { title: "Medine Turu", img: medine },
              { title: "Doha Turu", img: doha },
              { title: "Mısır Turu", img: misir },
              { title: "Balkan Turu", img: saraybosna },
            ].map((tour, index) => (
              <div
                key={index}
                style={{
                  minWidth: "230px",
                  maxWidth: "230px",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <img
                  src={tour.img}
                  alt={tour.title}
                  style={{
                    width: "100%",
                    height: "160px",
                    objectFit: "cover",
                  }}
                />
                <div style={{ padding: "15px" }}>
                  <h3
                    style={{
                      color: "#272B59",
                      fontSize: "18px",
                      marginBottom: "8px",
                    }}
                  >
                    {tour.title}
                  </h3>
                  <p style={{ fontSize: "14px", color: "#555" }}>
                    Yakında detaylarıyla burada olacak.
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Uygun Turu Bulalım Formu */}
      <UygunTurFormu />
    </div>
  );
}

export default Anasayfa;
